// AppContext.js
import React from 'react'

// 创建一个新的 Context
const HeaderContext = React.createContext()

export default HeaderContext
